import {
  LOAD_FIRMWARE_DOWNLOAD_PENDING,
  LOAD_FIRMWARE_DOWNLOAD_FULFILLED,
  LOAD_FIRMWARE_DOWNLOAD_REJECTED,
  CLEAR_FIRMWARE_MESSAGES,
  LOAD_FIRMWARE_RELEASES_PENDING,
  LOAD_FIRMWARE_RELEASES_FULFILLED,
  LOAD_FIRMWARE_RELEASES_REJECTED,
  LOAD_NEW_FIRMWARE_RELEASES_PENDING,
  LOAD_NEW_FIRMWARE_RELEASES_FULFILLED,
  LOAD_NEW_FIRMWARE_RELEASES_REJECTED,
  LOAD_FIRMWARE_RELEASE_DETAILS_PENDING,
  LOAD_FIRMWARE_RELEASE_DETAILS_FULFILLED,
  LOAD_FIRMWARE_RELEASE_DETAILS_REJECTED,
  LOAD_FIRMWARE_UPLOAD_FILES_PENDING,
  LOAD_FIRMWARE_UPLOAD_FILES_FULFILLED,
  LOAD_FIRMWARE_UPLOAD_FILES_REJECTED,
  LOAD_NEW_FIRMWARE_UPLOAD_FILES_PENDING,
  LOAD_NEW_FIRMWARE_UPLOAD_FILES_FULFILLED,
  LOAD_NEW_FIRMWARE_UPLOAD_FILES_REJECTED,
  LOAD_FIRMWARE_UPLOAD_DOCUMENTS_PENDING,
  LOAD_FIRMWARE_UPLOAD_DOCUMENTS_FULFILLED,
  LOAD_FIRMWARE_UPLOAD_DOCUMENTS_REJECTED,
  LOAD_NEW_FIRMWARE_UPLOAD_DOCUMENTS_PENDING,
  LOAD_NEW_FIRMWARE_UPLOAD_DOCUMENTS_FULFILLED,
  LOAD_NEW_FIRMWARE_UPLOAD_DOCUMENTS_REJECTED,
  LOAD_FIRMWARE_PREFIXES_PENDING,
  LOAD_FIRMWARE_PREFIXES_FULFILLED,
  LOAD_FIRMWARE_PREFIXES_REJECTED,
  LOAD_FIRMWARE_TYPES_PENDING,
  LOAD_FIRMWARE_TYPES_FULFILLED,
  LOAD_FIRMWARE_TYPES_REJECTED,
  LOAD_FIRMWARE_UPDATE_AVAILABLE_STATUS_PENDING,
  LOAD_FIRMWARE_UPDATE_AVAILABLE_STATUS_FULFILLED,
  LOAD_FIRMWARE_UPDATE_AVAILABLE_STATUS_REJECTED,
  POST_RELEASE_PENDING,
  POST_RELEASE_FULFILLED,
  POST_RELEASE_REJECTED,
  PUT_RELEASE_PENDING,
  PUT_RELEASE_FULFILLED,
  PUT_RELEASE_REJECTED,
  PATCH_FIRMWARE_FILE_PENDING,
  PATCH_FIRMWARE_FILE_FULFILLED,
  PATCH_FIRMWARE_FILE_REJECTED,
  PATCH_FIRMWARE_DOCUMENT_PENDING,
  PATCH_FIRMWARE_DOCUMENT_FULFILLED,
  PATCH_FIRMWARE_DOCUMENT_REJECTED,
  DELETE_RELEASE_PENDING,
  DELETE_RELEASE_FULFILLED,
  DELETE_RELEASE_REJECTED,
  DELETE_FIRMWARE_FILE_PENDING,
  DELETE_FIRMWARE_FILE_FULFILLED,
  DELETE_FIRMWARE_FILE_REJECTED,
  DELETE_FIRMWARE_DOCUMENT_PENDING,
  DELETE_FIRMWARE_DOCUMENT_FULFILLED,
  DELETE_FIRMWARE_DOCUMENT_REJECTED,
  LOAD_FIRMWARE_MODELS_PENDING,
  LOAD_FIRMWARE_MODELS_FULFILLED,
  LOAD_FIRMWARE_MODELS_REJECTED,
  CLEAR_RELEASE_DETAILS,
} from '../actions/firmware'
import i18n from 'i18next'

export default function firmware(state = {}, action) {
  switch (action.type) {
    case LOAD_FIRMWARE_DOWNLOAD_PENDING:
    case LOAD_FIRMWARE_RELEASES_PENDING:
    case LOAD_NEW_FIRMWARE_RELEASES_PENDING:
    case LOAD_FIRMWARE_RELEASE_DETAILS_PENDING:
    case LOAD_FIRMWARE_UPLOAD_FILES_PENDING:
    case LOAD_NEW_FIRMWARE_UPLOAD_FILES_PENDING:
    case LOAD_FIRMWARE_UPLOAD_DOCUMENTS_PENDING:
    case LOAD_NEW_FIRMWARE_UPLOAD_DOCUMENTS_PENDING:
    case LOAD_FIRMWARE_PREFIXES_PENDING:
    case LOAD_FIRMWARE_TYPES_PENDING:
    case LOAD_FIRMWARE_UPDATE_AVAILABLE_STATUS_PENDING:
    case POST_RELEASE_PENDING:
    case PUT_RELEASE_PENDING:
    case PATCH_FIRMWARE_FILE_PENDING:
    case PATCH_FIRMWARE_DOCUMENT_PENDING:
    case DELETE_RELEASE_PENDING:
    case DELETE_FIRMWARE_FILE_PENDING:
    case DELETE_FIRMWARE_DOCUMENT_PENDING:
    case LOAD_FIRMWARE_MODELS_PENDING:
      return {
        ...state,
        isLoading: true,
        errorMessage: null,
      }
    case LOAD_FIRMWARE_DOWNLOAD_REJECTED:
    case LOAD_FIRMWARE_RELEASES_REJECTED:
    case LOAD_NEW_FIRMWARE_RELEASES_REJECTED:
    case LOAD_FIRMWARE_UPLOAD_FILES_REJECTED:
    case LOAD_NEW_FIRMWARE_UPLOAD_FILES_REJECTED:
    case LOAD_FIRMWARE_RELEASE_DETAILS_REJECTED:
    case LOAD_FIRMWARE_UPLOAD_DOCUMENTS_REJECTED:
    case LOAD_NEW_FIRMWARE_UPLOAD_DOCUMENTS_REJECTED:
    case LOAD_FIRMWARE_PREFIXES_REJECTED:
    case LOAD_FIRMWARE_TYPES_REJECTED:
    case LOAD_FIRMWARE_UPDATE_AVAILABLE_STATUS_REJECTED:
    case POST_RELEASE_REJECTED:
    case PUT_RELEASE_REJECTED:
    case PATCH_FIRMWARE_FILE_REJECTED:
    case PATCH_FIRMWARE_DOCUMENT_REJECTED:
    case DELETE_RELEASE_REJECTED:
    case DELETE_FIRMWARE_FILE_REJECTED:
    case DELETE_FIRMWARE_DOCUMENT_REJECTED:
    case LOAD_FIRMWARE_MODELS_REJECTED:
      const errorMessageCode = action.payload.response?.data?.code

      return {
        ...state,
        isLoading: false,
        errorMessage: i18n.t([`error.${errorMessageCode}`, 'error.something_wrong']),
      }
    case LOAD_FIRMWARE_DOWNLOAD_FULFILLED:
      return {
        ...state,
        firmwares: action.payload.data,
        isLoading: false,
      }
    case LOAD_FIRMWARE_RELEASES_FULFILLED:
      const firmwareReleases = state?.firmwareReleases || []
      const newFirmwareReleasesIds = action.payload.data?.map((item) => item.id)
      const firmwareReleasesDifference = firmwareReleases.filter((x) => !newFirmwareReleasesIds.includes(x.id)).concat(action.payload.data)

      return {
        ...state,
        firmwareReleases: firmwareReleasesDifference,
        canLoadMoreFirmwareReleases: action.payload.nextPage,
        isLoading: false,
      }
    case LOAD_NEW_FIRMWARE_RELEASES_FULFILLED:
      return {
        ...state,
        firmwareReleases: action.payload.data,
        canLoadMoreFirmwareReleases: action.payload.nextPage,
        isLoading: false,
      }
    case LOAD_FIRMWARE_RELEASE_DETAILS_FULFILLED:
      return {
        ...state,
        releaseDetails: action.payload,
        isLoading: false,
      }
    case LOAD_FIRMWARE_UPLOAD_FILES_FULFILLED:
      const firmwareUploadFiles = state?.firmwareUploadFiles || []
      const newFirmwareUploadFilesIds = action.payload.data?.map((item) => item.id)
      const firmwareUploadFilesDifference = firmwareUploadFiles.filter((x) => !newFirmwareUploadFilesIds.includes(x.id)).concat(action.payload.data)

      return {
        ...state,
        firmwareUploadFiles: firmwareUploadFilesDifference,
        canLoadMoreFirmwareUploadFiles: action.payload.nextPage,
        isLoading: false,
      }
    case LOAD_NEW_FIRMWARE_UPLOAD_FILES_FULFILLED:
      return {
        ...state,
        firmwareUploadFiles: action.payload.data,
        canLoadMoreFirmwareUploadFiles: action.payload.nextPage,
        isLoading: false,
      }
    case LOAD_FIRMWARE_UPLOAD_DOCUMENTS_FULFILLED:
      const firmwareUploadDocuments = state?.firmwareUploadDocuments || []
      const newFirmwareUploadDocumentsIds = action.payload.data?.map((item) => item.id)
      const firmwareUploadDocumentsDifference = firmwareUploadDocuments.filter((x) => !newFirmwareUploadDocumentsIds.includes(x.id)).concat(action.payload.data)

      return {
        ...state,
        firmwareUploadDocuments: firmwareUploadDocumentsDifference,
        canLoadMoreFirmwareUploadDocuments: action.payload.nextPage,
        isLoading: false,
      }
    case LOAD_NEW_FIRMWARE_UPLOAD_DOCUMENTS_FULFILLED:
      return {
        ...state,
        firmwareUploadDocuments: action.payload.data,
        canLoadMoreFirmwareUploadDocuments: action.payload.nextPage,
        isLoading: false,
      }
    case LOAD_FIRMWARE_PREFIXES_FULFILLED:
      return {
        ...state,
        prefixes: action.payload,
        isLoading: false,
      }
    case LOAD_FIRMWARE_TYPES_FULFILLED:
      return {
        ...state,
        types: action.payload,
        isLoading: false,
      }
    case LOAD_FIRMWARE_UPDATE_AVAILABLE_STATUS_FULFILLED:
      const devicesUpdateStatusDictionary =
        action.payload?.reduce((acc, item) => {
          const [key, value] = Object.entries(item)[0]
          acc[key] = value
          return acc
        }, {}) || {}

      return {
        ...state,
        devicesUpdateAvailableStatus: devicesUpdateStatusDictionary,
        isLoading: false,
      }
    case POST_RELEASE_FULFILLED:
      const newRelease = {
        id: action.payload.id,
        name: action.payload.recordName,
        description: action.payload.description,
        date: action.payload.updatedAt,
        totalFiles: action.payload.files?.length || 0,
        isActive: action.payload.isActive,
        models: [...new Set(action.payload.files.map((file) => file.models).flat())],
      }

      return {
        ...state,
        firmwareReleases: [newRelease, ...state.firmwareReleases],
        isLoading: false,
        successMessage: i18n.t('firmware_context.release_created_successfully'),
      }
    case PUT_RELEASE_FULFILLED:
      const firmwareReleasesAfterEdit = state?.firmwareReleases.map((item) => {
        if (item.id === action.payload.id) {
          return {
            ...item,
            name: action.payload.recordName,
            models: action.payload.models || [],
            totalFiles: action.payload.files?.length || 0,
            isActive: action.payload.isActive,
          }
        }
        return item
      })

      return {
        ...state,
        firmwareReleases: firmwareReleasesAfterEdit,
        isLoading: false,
        successMessage: i18n.t('firmware_context.release_updated_successfully'),
      }
    case PATCH_FIRMWARE_FILE_FULFILLED:
      const updatedFirmwareUploadFiles = state?.firmwareUploadFiles?.map((item) => {
        if (item.id === action.payload.id) {
          return {
            ...item,
            ...action.payload,
          }
        }
        return item
      })

      return {
        ...state,
        firmwareUploadFiles: updatedFirmwareUploadFiles,
        ...(action.meta.releaseId &&
          action.meta.releaseId === state.releaseDetails?.id && {
            releaseDetails: { ...state.releaseDetails, files: state.releaseDetails.files?.map((f) => (f.id === action.payload.id ? action.payload : f)) },
          }),
        isLoading: false,
        successMessage: i18n.t('file_updated_successfully'),
      }
    case PATCH_FIRMWARE_DOCUMENT_FULFILLED:
      const updatedFirmwareUploadDocuments = state?.firmwareUploadDocuments?.map((item) => {
        if (item.id === action.payload.id) {
          return {
            ...item,
            ...action.payload,
          }
        }
        return item
      })

      return {
        ...state,
        firmwareUploadDocuments: updatedFirmwareUploadDocuments,
        ...(action.meta.releaseId &&
          action.meta.releaseId === state.releaseDetails?.id && {
            releaseDetails: { ...state.releaseDetails, files: state.releaseDetails.files?.map((f) => (f.id === action.payload.id ? action.payload : f)) },
          }),
        isLoading: false,
        successMessage: i18n.t('file_updated_successfully'),
      }
    case DELETE_RELEASE_FULFILLED:
      const firmwareReleasesAfterDelete = state?.firmwareReleases.filter((item) => item.id !== action.meta.releaseId)

      return {
        ...state,
        firmwareReleases: firmwareReleasesAfterDelete,
        isLoading: false,
        successMessage: i18n.t('firmware_context.release_deleted_successfully'),
      }
    case DELETE_FIRMWARE_FILE_FULFILLED:
      const remainingFirmwareFiles = state?.firmwareUploadFiles?.filter((item) => item.id !== action.meta.fileId)

      return {
        ...state,
        firmwareUploadFiles: remainingFirmwareFiles,
        ...(action.meta.releaseId &&
          action.meta.releaseId === state.releaseDetails?.id && {
            releaseDetails: { ...state.releaseDetails, files: state.releaseDetails.files?.filter((f) => f.id !== action.meta.fileId) },
          }),
        ...(action.meta.releaseId && {
          firmwareReleases: state.firmwareReleases?.map((item) => {
            if (item.id === action.meta.releaseId) {
              return {
                ...item,
                totalFiles: item.totalFiles - 1,
              }
            }
            return item
          }),
        }),
        isLoading: false,
        successMessage: i18n.t('file_deleted_successfully'),
      }
    case DELETE_FIRMWARE_DOCUMENT_FULFILLED:
      const remainingFirmwareDocuments = state?.firmwareUploadDocuments?.filter((item) => item.id !== action.meta.fileId)

      return {
        ...state,
        firmwareUploadDocuments: remainingFirmwareDocuments,
        ...(action.meta.releaseId &&
          action.meta.releaseId === state.releaseDetails?.id && {
            releaseDetails: { ...state.releaseDetails, files: state.releaseDetails.files?.filter((f) => f.id !== action.meta.fileId) },
          }),
        ...(action.meta.releaseId && {
          firmwareReleases: state.firmwareReleases?.map((item) => {
            if (item.id === action.meta.releaseId) {
              return {
                ...item,
                totalFiles: item.totalFiles - 1,
              }
            }
            return item
          }),
        }),
        isLoading: false,
        successMessage: i18n.t('file_deleted_successfully'),
      }
    case CLEAR_RELEASE_DETAILS: {
      return {
        ...state,
        releaseDetails: null,
      }
    }
    case LOAD_FIRMWARE_MODELS_FULFILLED:
      return {
        ...state,
        firmwareModels: action.payload.data,
        isLoading: false,
      }
    case CLEAR_FIRMWARE_MESSAGES: {
      return {
        ...state,
        errorMessage: null,
        successMessage: null,
      }
    }
    default:
      return state
  }
}

